import { AppComponent } from './app.component';
import { Routes } from '@angular/router';

import { LoginComponent } from './_pages/login/login.component';
import { DashboardComponent } from './_pages/dashboard/dashboard.component';
import { TopBarComponent } from './_shared/top-bar/top-bar.component';
import { LeftSideBarComponent } from './_shared/left-side-bar/left-side-bar.component';
import { CenterContentComponent } from './_shared/center-content/center-content.component';

import { AuthGuard } from './_guards/auth.guard';
// Cliente
import { CrearClienteComponent } from './_components/cliente/crear-cliente/crear-cliente.component';
import { ListarClientesComponent } from './_components/cliente/listar-clientes/listar-clientes.component';
import { VerClienteComponent } from './_components/cliente/ver-cliente/ver-cliente.component';
import { RegistrarAbastecimientoComponent } from './_components/cliente/registrar-abastecimiento/registrar-abastecimiento.component';
import { ListarContratosClienteComponent } from './_components/cliente/listar-contratos-cliente/listar-contratos-cliente.component';
import { VerEditarAbastecimientoComponent } from './_components/cliente/ver-editar-abastecimiento/ver-editar-abastecimiento.component';
import { ListarAbastecimientoComponent } from './_components/cliente/listar-abastecimiento/listar-abastecimiento.component';
// Notifiaciones
import { NotificacionesComponent } from './_components/notificaciones/notificaciones.component';
// Chat
import { ChatComponent } from './_components/chat/chat.component';
// Comisiones
import { ComisionesComponent } from './_components/comisiones/comisiones.component';
import { FormularioComponent } from './_components/comisiones/formulario/formulario.component';
// Cotizador
import { CotizadorComponent } from './_components/operaciones/cotizador/cotizador.component';
import { ListarCotizacionesComponent } from './_components/listar-cotizaciones/listar-cotizaciones.component';
import { VerCotizacionComponent } from './_components/ver-cotizacion/ver-cotizacion.component';
// Operaciones
// Almacén
import { ListarClientesOrdenComponent } from './_components/operaciones/listar-clientes-orden/listar-clientes-orden.component';
import { ListarOrdenTrabajoComponent } from './_components/operaciones/listar-orden-trabajo/listar-orden-trabajo.component';
import { MaterialAlmacenComponent } from './_components/operaciones/material-almacen/material-almacen.component';
import { MenuComponent } from './_components/operaciones/menu/menu.component';
import { ClientesObraComponent } from './_components/operaciones/clientes-obra/clientes-obra.component';
import { EntradasMaterialComponent } from './_components/operaciones/entradas-material/entradas-material.component';
import { MovimientosAlmacenComponent } from './_components/operaciones/movimientos-almacen/movimientos-almacen.component';
import { SalidasMaterialComponent } from './_components/operaciones/salidas-material/salidas-material.component';
import { AlmacenEnEsperaComponent } from './_components/operaciones/almacen-en-espera/almacen-en-espera.component';
import { MaterialResguardoComponent } from './_components/operaciones/material-resguardo/material-resguardo.component';
import { ListarApoyoTraspasoComponent } from './_components/operaciones/listar-apoyo-traspaso/listar-apoyo-traspaso.component';
import { MaterialApoyoTraspasoComponent } from './_components/operaciones/material-apoyo-traspaso/material-apoyo-traspaso.component';
import { MaterialPendienteApoyoComponent } from './_components/operaciones/material-pendiente-apoyo/material-pendiente-apoyo.component';
import { ListarOrdenPendienteApoyoComponent } from './_components/operaciones/listar-orden-pendiente-apoyo/listar-orden-pendiente-apoyo.component';
// Contabilidad
import { ListarClientesPreautorizadosComponent } from './_components/contabilidad/listar-clientes-preautorizados/listar-clientes-preautorizados.component';
import { ControlInternoComponent } from './_components/indicadores/control-interno/control-interno.component';
// Sistema
import { SistemaTicketsComponent } from './_components/sistemas/sistema-tickets/sistema-tickets.component';
// Formatos
import { SolicitudTransferenciasComponent } from './_components/formatos/solicitud-transferencias/solicitud-transferencias.component';
import { AyudaComponent } from './_components/ayuda/ayuda.component';

// Declaración de modulos
export const DECLARATION_MODULES: any = [
    LoginComponent,
    DashboardComponent,
    TopBarComponent,
    LeftSideBarComponent,
    CenterContentComponent,
    CrearClienteComponent,
    ListarClientesComponent,
    VerClienteComponent,
    RegistrarAbastecimientoComponent,
    ListarContratosClienteComponent,
    VerEditarAbastecimientoComponent,
    ListarAbastecimientoComponent,
    ChatComponent,
    ComisionesComponent,
    FormularioComponent,
    CotizadorComponent,
    ListarCotizacionesComponent,
    VerCotizacionComponent,
    ListarClientesPreautorizadosComponent,
    ListarClientesOrdenComponent,
    ControlInternoComponent,
    ListarOrdenTrabajoComponent,
    SistemaTicketsComponent,
    MaterialAlmacenComponent,
    MenuComponent,
    ClientesObraComponent,
    EntradasMaterialComponent,
    MovimientosAlmacenComponent,
    SalidasMaterialComponent,
    AlmacenEnEsperaComponent,
    MaterialResguardoComponent,
    ListarApoyoTraspasoComponent,
    MaterialApoyoTraspasoComponent,
    MaterialPendienteApoyoComponent,
    ListarOrdenPendienteApoyoComponent,
    SolicitudTransferenciasComponent,
    AyudaComponent
];


// Rutas
export const APP_ROUTES: Routes = [

    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: '', component: DashboardComponent, canActivate: [AuthGuard], children: [
        { path: 'protected', component: ChatComponent, canActivate: [AuthGuard], },
        {
            path: 'dashboard',
            component: CenterContentComponent,
            canActivate: [AuthGuard],
            children: [
                { path: 'notificaciones', component: NotificacionesComponent},
                { path: 'listarClientes', component: ListarClientesComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'crearCliente', component: CrearClienteComponent },
                { path: 'verCliente/:id', component: VerClienteComponent, runGuardsAndResolvers: 'always'},
                { path: 'verCliente/:id/contratos', component: ListarContratosClienteComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'verCliente/:id/contratos/:idContrato/abastecimiento', component: ListarAbastecimientoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'verCliente/:id/contratos/abastecimiento/alquiler', component: RegistrarAbastecimientoComponent, runGuardsAndResolvers: 'paramsChange'},
                // { path: 'verCliente/:id/contratos/:idContrato/abastecimiento/alquiler', component: RegistrarAbastecimientoComponent, runGuardsAndResolvers: 'paramsChange'},
                { path: 'verCliente/:id/contratos/:idContrato/abastecimiento/reabastecimiento', component: RegistrarAbastecimientoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'verCliente/:id/contratos/:idContrato/abastecimiento/venta', component: RegistrarAbastecimientoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'verCliente/:id/contratos/:idContrato/abastecimiento/:idAbastecimiento', component: VerEditarAbastecimientoComponent, runGuardsAndResolvers: 'paramsChange'},
                { path: 'comisiones', component: ComisionesComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'comisiones/formulario', component: FormularioComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'cotizaciones', component: ListarCotizacionesComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'cotizaciones/cotizador', component: CotizadorComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'verCotizaciones/:idCotizacion', component: VerCotizacionComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'listarClientesPreautorizados', component: ListarClientesPreautorizadosComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'listarClienteOrdenPendiente', component: ListarClientesOrdenComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'indicador', component: ControlInternoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'tickets/:idTicket', component: SistemaTicketsComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'solicitudTransferencias', component: SolicitudTransferenciasComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen', component: MenuComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/materialAlmacen', component: MaterialAlmacenComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/clientesObra', component: ClientesObraComponent, runGuardsAndResolvers: 'paramsChange'},
                { path: 'menuAlmacen/enEspera', component: AlmacenEnEsperaComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/clientesObra/:idEntradas', component: EntradasMaterialComponent, runGuardsAndResolvers: 'paramsChange'},
                { path: 'menuAlmacen/movimientos', component: MovimientosAlmacenComponent, runGuardsAndResolvers: 'paramsChange'},
                { path: 'menuAlmacen/listarOrdenTrabajo', component: ListarOrdenTrabajoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/listarOrdenTrabajo/salidasMaterial/:idOrden', component: SalidasMaterialComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/materialResguardo', component: MaterialResguardoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/listarApoyoTraspaso', component: ListarApoyoTraspasoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/listarApoyoTraspaso/materialApoyoTraspaso/:idOrden', component: MaterialApoyoTraspasoComponent, runGuardsAndResolvers: 'paramsChange'},
                { path: 'menuAlmacen/listarApoyoTraspaso/materialApoyoSolicitud/:idOrden', component: MaterialPendienteApoyoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'menuAlmacen/listarOrdenApoyo', component: ListarOrdenPendienteApoyoComponent, runGuardsAndResolvers: 'paramsChange' },
                { path: 'ayuda', component: AyudaComponent, runGuardsAndResolvers: 'paramsChange' }
            ]
        }
    ]}
];



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/app.routes.ts